export default __webpack_public_path__ + "static/media/hippa_logo.e093328d.png";